import { render, staticRenderFns } from "./LunchNotesWeekDay.vue?vue&type=template&id=ab3b35a0&"
import script from "./LunchNotesWeekDay.vue?vue&type=script&lang=js&"
export * from "./LunchNotesWeekDay.vue?vue&type=script&lang=js&"
import style0 from "./LunchNotesWeekDay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports